"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var StreamImageStore = /*#__PURE__*/function () {
  function StreamImageStore(client, token) {
    (0, _classCallCheck2.default)(this, StreamImageStore);
    this.client = client;
    this.token = token;
  } // React Native does not auto-detect MIME type, you need to pass that via contentType
  // param. If you don't then Android will refuse to perform the upload


  (0, _createClass2.default)(StreamImageStore, [{
    key: "upload",
    value: function upload(uri, name, contentType, onUploadProgress) {
      /**
       * upload an Image File instance or a readable stream of data
       * @param {File|Buffer|string} uri - File object or Buffer or URI
       * @param {string} [name] - file name
       * @param {string} [contentType] - mime-type
       * @param {function} [onUploadProgress] - browser only, Function that is called with upload progress
       * @return {Promise}
       */
      return this.client.upload('images/', uri, name, contentType, onUploadProgress);
    }
  }, {
    key: "delete",
    value: function _delete(uri) {
      return this.client.delete({
        url: "images/",
        qs: {
          url: uri
        },
        signature: this.token
      });
    }
  }, {
    key: "process",
    value: function process(uri, options) {
      var params = (0, _extends2.default)(options, {
        url: uri
      });

      if (Array.isArray(params.crop)) {
        params.crop = params.crop.join(',');
      }

      return this.client.get({
        url: "images/",
        qs: params,
        signature: this.token
      });
    }
  }, {
    key: "thumbnail",
    value: function thumbnail(uri, w, h) {
      var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        crop: 'center',
        resize: 'clip'
      },
          crop = _ref.crop,
          resize = _ref.resize;

      return this.process(uri, {
        w: w,
        h: h,
        crop: crop,
        resize: resize
      });
    }
  }]);
  return StreamImageStore;
}();

exports.default = StreamImageStore;